
import React, { useEffect, useState } from 'react';
import { t, setLang, getLang } from '../i18n';


export default function Settings() {
  const [mode, setMode] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('themeMode') || 'auto';
    }
    return 'auto';
  });

  useEffect(() => {
    if (mode === 'auto') {
      document.body.classList.remove('dark-mode', 'light-mode');
    } else {
      document.body.classList.remove('dark-mode', 'light-mode');
      document.body.classList.add(`${mode}-mode`);
    }
    if (typeof window !== 'undefined') {
      localStorage.setItem('themeMode', mode);
    }
  }, [mode]);

  const handleLangChange = (lang) => {
    setLang(lang);
    window.location.reload();
  };

  return (
    <div className="container py-4 d-flex justify-content-center align-items-center" style={{minHeight:'70vh'}}>
      <div className="card shadow-sm p-4" style={{maxWidth: 420, width: '100%'}}>
        <h2 className="mb-4 text-center"><i className="bi bi-gear me-2"></i>{t('settings')}</h2>
        <div className="mb-4">
          <div className="mb-2 fw-bold text-uppercase small text-secondary">{t('language')}</div>
          <div className="d-flex gap-2 justify-content-center">
            <button
              type="button"
              className={`btn btn-outline-secondary d-flex align-items-center${getLang() === 'en' ? ' active' : ''}`}
              aria-label="Switch to English"
              onClick={() => handleLangChange('en')}
              style={{fontSize: '1.1em', padding: '0.4em 1.1em'}}
            >
              <span role="img" aria-label="English" style={{fontSize:'1.3em'}}>🇬🇧</span>
              <span className="ms-2">English</span>
            </button>
            <button
              type="button"
              className={`btn btn-outline-secondary d-flex align-items-center${getLang() === 'fi' ? ' active' : ''}`}
              aria-label="Vaihda suomeksi"
              onClick={() => handleLangChange('fi')}
              style={{fontSize: '1.1em', padding: '0.4em 1.1em'}}
            >
              <span role="img" aria-label="Suomi" style={{fontSize:'1.3em'}}>🇫🇮</span>
              <span className="ms-2">Suomi</span>
            </button>
          </div>
        </div>
        <div className="mb-2">
          <div className="mb-2 fw-bold text-uppercase small text-secondary">{t('themeMode')}</div>
          <div className="d-flex gap-2 justify-content-center">
            <button
              type="button"
              className={`btn btn-outline-secondary${mode === 'auto' ? ' active' : ''}`}
              onClick={() => setMode('auto')}
            >{t('autoMode')}</button>
            <button
              type="button"
              className={`btn btn-outline-secondary${mode === 'light' ? ' active' : ''}`}
              onClick={() => setMode('light')}
            >{t('lightMode')}</button>
            <button
              type="button"
              className={`btn btn-outline-secondary${mode === 'dark' ? ' active' : ''}`}
              onClick={() => setMode('dark')}
            >{t('darkMode')}</button>
          </div>
        </div>
        {/* More settings can be added here in the future */}
      </div>
    </div>
  );
}
